"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = exports.Akord = void 0;
const akord_1 = require("./akord");
Object.defineProperty(exports, "Akord", { enumerable: true, get: function () { return akord_1.Akord; } });
const akord_auth_1 = require("@akord/akord-auth");
Object.defineProperty(exports, "Auth", { enumerable: true, get: function () { return akord_auth_1.Auth; } });
/**
 * @param  {Wallet} wallet
 * @param  {ClientConfig={}} config
 * @returns Promise with Akord Client instance
 */
akord_1.Akord.init = function (wallet, config = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        akord_auth_1.Auth.configure(config);
        return new akord_1.Akord(wallet, config);
    });
};
__exportStar(require("./types"), exports);
__exportStar(require("./plugin"), exports);
